module.exports = __webpack_public_path__ + "static/media/pdf-large.bc449419.svg";